module.exports = __webpack_public_path__ + "img/blue-menu.9e72a92f.png";